import React, { useEffect, useState } from 'react';
import '../../Styles/Styles.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom'; 
import { useCookies } from 'react-cookie';
import { toast } from 'react-toastify';
import CssClass from "../../Styles/common.module.css";
import http from "../../Common/http-common";
import * as common from "../../Common/common";
import * as Comp from "../../Common/CommonComponents";
import { GetPageAuthorityFn } from "../../Common/authority";
import EntitlementUpdate from '../../Components/MasterSetup/Entitlements/EntitlementUpdate';
import EntitlementClaimUpdate from '../../Components/MasterSetup/Entitlements/EntitlementClaimUpdate';
import EntitlementDelete from '../../Components/MasterSetup/Entitlements/EntitlementDelete';
import EntitlementActivator from '../../Components/MasterSetup/Entitlements/EntitlementActivator';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquarePlus, faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';

const PAGE_NAME = "Entitlements.js";
const MODULE_ID = "WEB_MST_002";

const Entitlements = (props) => {
	const navigate = useNavigate();
	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
	const [showActivator, setShowActivator] = useState(false);
	const [showReceiptActivator, setShowReceiptActivator] = useState(false);
	const [showUpdate, setShowUpdate] = useState(false);
	const [showUpdateClaim, setShowUpdateClaim] = useState(false);
	const [showDelete, setShowDelete] = useState(false);
	const [selectedAL, setSelectedAL] = useState(false);
	const [selectedMC, setSelectedMC] = useState(false);
	const [selectedClaim, setSelectedClaim] = useState(false);
	const [loading, setLoading] = useState(false);
	const [loadingText, setLoadingText] = useState("Loading....")
	const [reload, setReload] = useState(false);
	const [alData, setAlData] = useState([]);
	const [mcData, setMcData] = useState([]);
	const [claimData, setClaimData] = useState([]);
	const [editData, setEditData] = useState([]);
	const [alCurrentPage, setAlCurrentPage] = useState(0);
	const [alRowsPerPage, setAlRowsPerPage] = useState(10);
	const [mcCurrentPage, setMcCurrentPage] = useState(0);
	const [mcRowsPerPage, setMcRowsPerPage] = useState(10);
	const [claimCurrentPage, setClaimCurrentPage] = useState(0);
	const [claimRowsPerPage, setClaimRowsPerPage] = useState(10);

	//#region Authority
	const [actionAuthority, setActionAuthority] = useState({
		READ: "N",
		WRITE: "N",
		READALL: "N",
	});
		
	useEffect(() => {
		let promise = GetPageAuthorityFn(userId, MODULE_ID);
		promise.then(
			(result) => {
				setActionAuthority(result);
				if (result.READ === "N") {
					navigate("/Dashboard");
				}
			},
			(error) => {
				setActionAuthority({
					READ: "N",
					WRITE: "N",
					READALL: "N",
				});
				common.c_LogWebError(PAGE_NAME, "GetPageAuthorityFn", error);
				toast.error(error);
				navigate("/Dashboard");
			}
		);
	}, [userId, navigate]);
	//#endregion

	useEffect(() => {
		if(actionAuthority.READ === 'Y') {
			let functionName = "useEffect Get Annual Leave List";
			try {
				setLoading(true);
				setLoadingText("Getting Annual Leave List, Please wait...");
				setAlData([]);
				const listItems = [];

				http
					.get("api/entitlement/GetAnnualLeave?_sysUser=" + userId, 
							{ timeout: 100000})
					.then((response) => {
						if (response.data.length > 0) {
							response.data.forEach((data) => {
								const date = new Date(data.UPDATE_DATETIME);
								const formattedDate =
									date.toLocaleDateString('en-GB') + ' ' + date.toLocaleTimeString('en-GB', {
										hour12: true,
										hour: '2-digit',
										minute: '2-digit',
									}).toUpperCase();

								listItems.push({
									key: data.ENTITLEMENT_LEAVE_ID,
									ENTITLEMENT_LEAVE_ID: data.ENTITLEMENT_LEAVE_ID,
									CATEGORY_TYPE_NAME: data.CATEGORY_TYPE_NAME,
									WORK_TYPE: data.EMP_WORKTYPE,
									YEAR_FROM: data.YEAR_FROM,
									YEAR_TO: data.YEAR_TO,
									DAYS: data.DAYS,
									STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
									UPDATE_DATETIME_RAW: data.UPDATE_DATETIME,
									UPDATE_DATETIME: formattedDate,
									USERNAME: data.USERNAME,
								});
							});
						}
						setAlData(listItems);
					})
				.catch((err) => {
					toast.error("Error on getting annual leave list. Please try again.");
					common.c_LogWebError(PAGE_NAME, functionName, err);
				})
				.finally(() => {
					setLoading(false);
					setLoadingText("Loading...");
				});
			} catch (err) {
				toast.error("Error on getting annual leave list. Please try again.");
				common.c_LogWebError(PAGE_NAME, functionName, err);
			}
		}
	}, [reload, actionAuthority, userId]);

	useEffect(() => {
		if(actionAuthority.READ === 'Y') {
			let functionName = "useEffect Get Medical Leave List";
			try {
				setLoading(true);
				setLoadingText("Getting Medical Leave List, Please wait...");
				setMcData([]);
				const listItems = [];

				http
					.get("api/entitlement/GetMedicalLeave?_sysUser=" + userId, 
							{ timeout: 100000})
					.then((response) => {
						if (response.data.length > 0) {
							response.data.forEach((data) => {
								const date = new Date(data.UPDATE_DATETIME);
								const formattedDate =
									date.toLocaleDateString('en-GB') + ' ' + date.toLocaleTimeString('en-GB', {
										hour12: true,
										hour: '2-digit',
										minute: '2-digit',
									}).toUpperCase();

								listItems.push({
									key: data.ENTITLEMENT_LEAVE_ID,
									ENTITLEMENT_LEAVE_ID: data.ENTITLEMENT_LEAVE_ID,
									CATEGORY_TYPE_NAME: data.CATEGORY_TYPE_NAME,
									WORK_TYPE: data.EMP_WORKTYPE,
									YEAR_FROM: data.YEAR_FROM,
									YEAR_TO: data.YEAR_TO,
									DAYS: data.DAYS,
									STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
									UPDATE_DATETIME_RAW: data.UPDATE_DATETIME,
									UPDATE_DATETIME: formattedDate,
									USERNAME: data.USERNAME,
								});
							});
						}
						setMcData(listItems);
					})
				.catch((err) => {
					toast.error("Error on getting medical leave list. Please try again.");
					common.c_LogWebError(PAGE_NAME, functionName, err);
				})
				.finally(() => {
					setLoading(false);
					setLoadingText("Loading...");
				});
			} catch (err) {
				toast.error("Error on getting medical leave list. Please try again.");
				common.c_LogWebError(PAGE_NAME, functionName, err);
			}
		}
	}, [reload, actionAuthority, userId]);

	useEffect(() => {
		if(actionAuthority.READ === 'Y') {
			let functionName = "useEffect Get Claim List";
			try {
				setLoading(true);
				setLoadingText("Getting Claim List, Please wait...");
				setMcData([]);
				const listItems = [];

				http
					.get("api/entitlement/GetClaim?_sysUser=" + userId, 
							{ timeout: 100000})
					.then((response) => {
						if (response.data.length > 0) {
							response.data.forEach((data) => {
								const date = new Date(data.UPDATE_DATETIME);
								const formattedDate =
									date.toLocaleDateString('en-GB') + ' ' + date.toLocaleTimeString('en-GB', {
										hour12: true,
										hour: '2-digit',
										minute: '2-digit',
									}).toUpperCase();

								listItems.push({
									key: data.ENTITLEMENT_CLAIM_ID,
									ENTITLEMENT_CLAIM_ID: data.ENTITLEMENT_CLAIM_ID,
									CATEGORY_TYPE_NAME: data.CATEGORY_TYPE_NAME,
									AMOUNT: data.AMOUNT,
									RECEIPT_FLAG: data.RECEIPT_FLAG ?? "N",
									REMARK: data.REMARK,
									STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
									UPDATE_DATETIME_RAW: data.UPDATE_DATETIME,
									UPDATE_DATETIME: formattedDate,
									USERNAME: data.USERNAME,
								});
							});
						}
						setClaimData(listItems);
					})
				.catch((err) => {
					toast.error("Error on getting claim list. Please try again.");
					common.c_LogWebError(PAGE_NAME, functionName, err);
				})
				.finally(() => {
					setLoading(false);
					setLoadingText("Loading...");
				});
			} catch (err) {
				toast.error("Error on getting claim list. Please try again.");
				common.c_LogWebError(PAGE_NAME, functionName, err);
			}
		}
	}, [reload, actionAuthority, userId]);

	const onReloadHandler = () => {
		setReload(!reload);
	};

	const onLoadingHandler = (load, text) => {
		setLoading(load);
		setLoadingText(text);
	};

	const showUpdateModal = (e, row) => {
		setShowUpdate(!showUpdate);
		setEditData(row);
	};

	const hideUpdateModal = () => {
		setShowUpdate(!showUpdate);
		setEditData(null);
	};

	const showUpdateClaimModal = (e, row) => {
		setShowUpdateClaim(!showUpdateClaim);
		setEditData(row);
	};

	const hideUpdateClaimModal = () => {
		setShowUpdateClaim(!showUpdateClaim);
		setEditData(null);
	};

	const showDeleteModal = (row) => {
		setShowDelete(true);
		setEditData(row);
	};

	const hideDeleteModal = () => {
		setShowDelete(false);
		setEditData(null);
	};
	
	const showActivatorModal = (e, row) => {
		setShowActivator(!showActivator);
		setEditData(row);
	};

	const hideActivatorModal = () => {
		setShowActivator(!showActivator);
		setEditData(null);
	};

	const showReceiptActivatorModal = (e, row) => {
		setShowReceiptActivator(!showReceiptActivator);
		setEditData(row);
	};

	const hideReceiptActivatorModal = () => {
		setShowReceiptActivator(!showReceiptActivator);
		setEditData(null);
	};
		
	const renderAnnualLeaveHeader = () => {
		return (
			<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
				<span className="text-lg font-semibold" style={{ fontSize: '22px' }}>Annual Leave</span>
			</div>
		);
	};

	const renderMedicalLeaveHeader = () => {
		return (
			<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
				<span className="text-lg font-semibold" style={{ fontSize: '22px' }}>Medical Leave</span>
			</div>
		);
	};

	const renderClaimHeader = () => {
		return (
			<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
				<span className="text-lg font-semibold" style={{ fontSize: '22px' }}>Claim</span>
			</div>
		);
	};
		
	const TruncatedText = ({ text = '', maxLength = 105 }) => {
		const [expanded, setExpanded] = useState(false);
	
		if (!text) return null;
	
		const isLong = text.length > maxLength;
		const displayText = expanded || !isLong ? text : text.slice(0, maxLength) + '...';
	
		return (
			<div>
				<span>{displayText}</span>
				{isLong && (
					<span
						onClick={() => setExpanded((prev) => !prev)}
						style={{ color: '#007bff', cursor: 'pointer', marginLeft: '5px' }}
					>
						{expanded ? 'Show less' : 'Read more'}
					</span>
				)}
			</div>
		);
	};
	//#endregion

	return (
		<>
		<div className={`${CssClass.cardTwo} ${CssClass.tableCardTwo}`}>
			<div style={{ width: "100%" }}>
				<DataTable value={alData} dataKey="ENTITLEMENT_LEAVE_ID" header={renderAnnualLeaveHeader()}
					selectionMode="multiple" selection={selectedAL} onSelectionChange={(e) => setSelectedAL(e.value)}
					loading={loading} removableSort emptyMessage="No annual leave found." first={alCurrentPage * alRowsPerPage}
					paginator rows={alRowsPerPage} onPage={(e) => { setAlCurrentPage(e.page); setAlRowsPerPage(e.rows); }} rowsPerPageOptions={[10, 20, 30, 40, 50]} 
					scrollable showGridlines className="datatable" tableStyle={{ minWidth: '50rem' }}
				>
					<Column
						header="Action"
						body={(rowData) => (
							<div style={{ textAlign: "-webkit-center" }} className={CssClass.tdBtnActionWrapperTwo}>
                  {(actionAuthority.WRITE === "Y")&& (
										<span title="Modify">
											<Comp.Button
												id="btnEdit"
												type="general"
												onClick={(e) => showUpdateModal(e, rowData)}
												style={{ width: "50px", height: "35px", marginTop: "2px", marginBottom: "2px" }}
											>
												<FontAwesomeIcon icon={faPenToSquare} />
											</Comp.Button>
										</span>
                  )}
                  {(actionAuthority.WRITE === "Y")&& (
										<span title="Delete">
											<Comp.Button
												id="btnDelete"
												type="delete"
												onClick={() => showDeleteModal(rowData)}
												style={{ width: "50px", height: "35px" }}
											>
												<FontAwesomeIcon icon={faTrashCan} />
											</Comp.Button>
										</span>
                  )}
							</div>
						)}
						style={{
							width: '90px'
						}}
					/>
					<Column
						header="#"
						body={(rowData, options) => options.rowIndex + 1}
						style={{ width: '2.5rem', height: "40px", textAlign: 'center' }}
					/>
					<Column field="WORK_TYPE" header="Work Type" sortable style={{ width: '10rem' }}></Column>
					<Column field="YEAR_FROM" header="From Year" sortable></Column>
					<Column field="YEAR_TO" header="To Year" sortable></Column>
					<Column field="DAYS" header="Days" sortable></Column>
					<Column
						field="STATUS"
						header="Status"
						sortable
						style={{ textAlign: 'center', width: '60px' }}
						body={(rowData) => {
							const className =
								rowData.STATUS === "Active"
									? CssClass.activeStatus
									: CssClass.inactiveStatus;

							const handleToggle = (e, rowData) => {
								showActivatorModal(e, rowData);
							};

							return (
								<div className={CssClass.toggleWrapper}>
									<label className={CssClass.switch}>
										<input
											type="checkbox"
											checked={rowData.STATUS === "Active"}
											onChange={(e) => handleToggle(e, rowData)}
										/>
										<span className={CssClass.sliderRound}></span>
									</label>
								</div>
							);
						}}
					/>
					<Column field="UPDATE_DATETIME" header="Last Update" sortable
            sortFunction={(e) => {
              const parseDate = (dateStr) => {
                if (!dateStr) return new Date(0);

                const [datePart, timePart] = dateStr.split(' ');
                const [day, month, year] = datePart.split('/');

                return new Date(
                  parseInt(year),
                  parseInt(month) - 1,
                  parseInt(day),
                  ...(timePart ? timePart.split(':').map(Number) : [0, 0, 0])
                );
              };

              const sorted = [...e.data].sort((a, b) => {
                const dateA = parseDate(a.UPDATE_DATETIME);
                const dateB = parseDate(b.UPDATE_DATETIME);

                return (dateA - dateB) * e.order;
              });

              return sorted;
            }}
          />
					<Column field="USERNAME" header="Updated By" sortable></Column>
				</DataTable>
			</div>
			<br/>
		</div>

		<div className={`${CssClass.cardTwo} ${CssClass.tableCardTwo}`}>
			<div style={{ width: "100%" }}>
				<DataTable value={mcData} dataKey="ENTITLEMENT_LEAVE_ID" header={renderMedicalLeaveHeader()}
					selectionMode="multiple" selection={selectedMC} onSelectionChange={(e) => setSelectedMC(e.value)}
					loading={loading} removableSort emptyMessage="No medical leave found." first={mcCurrentPage * mcRowsPerPage}
					paginator rows={mcRowsPerPage} onPage={(e) => { setMcCurrentPage(e.page); setMcRowsPerPage(e.rows); }} rowsPerPageOptions={[10, 20, 30, 40, 50]} 
					scrollable showGridlines className="datatable" tableStyle={{ minWidth: '50rem' }}
				>
					<Column
						header="Action"
						body={(rowData) => (
							<div style={{ textAlign: "-webkit-center" }} className={CssClass.tdBtnActionWrapperTwo}>
                  {(actionAuthority.WRITE === "Y")&& (
										<span title="Modify">
											<Comp.Button
												id="btnEdit"
												type="general"
												onClick={(e) => showUpdateModal(e, rowData)}
												style={{ width: "50px", height: "35px", marginTop: "2px", marginBottom: "2px" }}
											>
												<FontAwesomeIcon icon={faPenToSquare} />
											</Comp.Button>
										</span>
                  )}
                  {(actionAuthority.WRITE === "Y")&& (
										<span title="Delete">
											<Comp.Button
												id="btnDelete"
												type="delete"
												onClick={() => showDeleteModal(rowData)}
												style={{ width: "50px", height: "35px" }}
											>
												<FontAwesomeIcon icon={faTrashCan} />
											</Comp.Button>
										</span>
                  )}
							</div>
						)}
						style={{
							width: '90px'
						}}
					/>
					<Column
						header="#"
						body={(rowData, options) => options.rowIndex + 1}
						style={{ width: '2.5rem', height: "40px", textAlign: 'center' }}
					/>
					<Column field="WORK_TYPE" header="Work Type" sortable style={{ width: '10rem' }}></Column>
					<Column field="CATEGORY_TYPE_NAME" header="Leave Type" sortable style={{ width: '10rem' }}></Column>
					<Column field="YEAR_FROM" header="From Year" sortable></Column>
					<Column field="YEAR_TO" header="To Year" sortable></Column>
					<Column field="DAYS" header="Days" sortable></Column>
					<Column
						field="STATUS"
						header="Status"
						sortable
						style={{ textAlign: 'center', width: '60px' }}
						body={(rowData) => {
							const className =
								rowData.STATUS === "Active"
									? CssClass.activeStatus
									: CssClass.inactiveStatus;

							const handleToggle = (e, rowData) => {
								showActivatorModal(e, rowData);
							};

							return (
								<div className={CssClass.toggleWrapper}>
									<label className={CssClass.switch}>
										<input
											type="checkbox"
											checked={rowData.STATUS === "Active"}
											onChange={(e) => handleToggle(e, rowData)}
										/>
										<span className={CssClass.sliderRound}></span>
									</label>
								</div>
							);
						}}
					/>
					<Column field="UPDATE_DATETIME" header="Last Update" sortable
            sortFunction={(e) => {
              const parseDate = (dateStr) => {
                if (!dateStr) return new Date(0);

                const [datePart, timePart] = dateStr.split(' ');
                const [day, month, year] = datePart.split('/');

                return new Date(
                  parseInt(year),
                  parseInt(month) - 1,
                  parseInt(day),
                  ...(timePart ? timePart.split(':').map(Number) : [0, 0, 0])
                );
              };

              const sorted = [...e.data].sort((a, b) => {
                const dateA = parseDate(a.UPDATE_DATETIME);
                const dateB = parseDate(b.UPDATE_DATETIME);

                return (dateA - dateB) * e.order;
              });

              return sorted;
            }}
          />
					<Column field="USERNAME" header="Updated By" sortable></Column>
				</DataTable>
			</div>
			<br/>
		</div>

		<div className={`${CssClass.cardTwo} ${CssClass.tableCardTwo}`}>
			<div style={{ width: "100%" }}>
				<DataTable value={claimData} dataKey="ENTITLEMENT_CLAIM_ID" header={renderClaimHeader()}
					selectionMode="multiple" selection={selectedClaim} onSelectionChange={(e) => setSelectedClaim(e.value)}
					loading={loading} removableSort emptyMessage="No claim found." first={claimCurrentPage * claimRowsPerPage}
					paginator rows={claimRowsPerPage} onPage={(e) => { setClaimCurrentPage(e.page); setClaimRowsPerPage(e.rows); }} rowsPerPageOptions={[10, 20, 30, 40, 50]} 
					scrollable showGridlines className="datatable" tableStyle={{ minWidth: '50rem' }}
				>
					<Column
						header="Action"
						body={(rowData) => (
							<div style={{ textAlign: "-webkit-center" }} className={CssClass.tdBtnActionWrapperTwo}>
                  {(actionAuthority.WRITE === "Y")&& (
										<span title="Modify">
											<Comp.Button
												id="btnEdit"
												type="general"
												onClick={(e) => showUpdateClaimModal(e, rowData)}
												style={{ width: "50px", height: "35px", marginTop: "2px", marginBottom: "2px" }}
											>
												<FontAwesomeIcon icon={faPenToSquare} />
											</Comp.Button>
										</span>
                  )}
                  {(actionAuthority.WRITE === "Y")&& (
										<span title="Delete">
											<Comp.Button
												id="btnDelete"
												type="delete"
												onClick={() => showDeleteModal(rowData)}
												style={{ width: "50px", height: "35px" }}
											>
												<FontAwesomeIcon icon={faTrashCan} />
											</Comp.Button>
										</span>
                  )}
							</div>
						)}
						style={{
							width: '90px'
						}}
					/>
					<Column
						header="#"
						body={(rowData, options) => options.rowIndex + 1}
						style={{ width: '2.5rem', height: "40px", textAlign: 'center' }}
					/>
					<Column field="CATEGORY_TYPE_NAME" header="Type" sortable style={{ width: '130px' }}></Column>
					<Column field="AMOUNT" header="Amount (RM)" sortable style={{ width: '80px' }}></Column>
					<Column
						field="RECEIPT_FLAG"
						header="Receipt"
						sortable
						style={{ textAlign: 'center', width: '70px' }}
						body={(rowData) => {
							const handleToggle = (e, rowData) => {
								showReceiptActivatorModal(e, rowData);
							};
							return (
								<div className={CssClass.toggleWrapper}>
									<label className={CssClass.switch}>
										<input
											type="checkbox"
											checked={rowData.RECEIPT_FLAG === "Y"}
											onChange={(e) => handleToggle(e, rowData)}
										/>
										<span className={CssClass.sliderRound}></span>
									</label>
								</div>
							);
						}}
					/>
					<Column field="REMARK" header="Remark" sortable style={{ width: '360px' }}
						body={(rowData) => 
							<TruncatedText text={rowData.REMARK} />
						}
					/>
					<Column
						field="STATUS"
						header="Status"
						sortable
						style={{ textAlign: 'center', width: '60px' }}
						body={(rowData) => {
							const className =
								rowData.STATUS === "Active"
									? CssClass.activeStatus
									: CssClass.inactiveStatus;

							const handleToggle = (e, rowData) => {
								showActivatorModal(e, rowData);
							};

							return (
								<div className={CssClass.toggleWrapper}>
									<label className={CssClass.switch}>
										<input
											type="checkbox"
											checked={rowData.STATUS === "Active"}
											onChange={(e) => handleToggle(e, rowData)}
										/>
										<span className={CssClass.sliderRound}></span>
									</label>
								</div>
							);
						}}
					/>
					<Column field="UPDATE_DATETIME" header="Last Update" sortable
            sortFunction={(e) => {
              const parseDate = (dateStr) => {
                if (!dateStr) return new Date(0);

                const [datePart, timePart] = dateStr.split(' ');
                const [day, month, year] = datePart.split('/');

                return new Date(
                  parseInt(year),
                  parseInt(month) - 1,
                  parseInt(day),
                  ...(timePart ? timePart.split(':').map(Number) : [0, 0, 0])
                );
              };

              const sorted = [...e.data].sort((a, b) => {
                const dateA = parseDate(a.UPDATE_DATETIME);
                const dateB = parseDate(b.UPDATE_DATETIME);

                return (dateA - dateB) * e.order;
              });

              return sorted;
            }}
          />
					<Column field="USERNAME" header="Updated By" sortable></Column>
				</DataTable>
			</div>
			<br/>
		</div>

		{loading && <Comp.Loading>{loadingText}</Comp.Loading>}
		<Comp.AlertPopup />

		<EntitlementUpdate
			page={props.page}
			module={MODULE_ID}
			showHide={showUpdate}
			editData={editData}
			onHide={hideUpdateModal}
			onReload={onReloadHandler}
			onLoading={onLoadingHandler}
		/>

		<EntitlementClaimUpdate
			page={props.page}
			module={MODULE_ID}
			showHide={showUpdateClaim}
			editData={editData}
			onHide={hideUpdateClaimModal}
			onReload={onReloadHandler}
			onLoading={onLoadingHandler}
		/>

		{showDelete && (
			<EntitlementDelete
				page={props.page}
				module={MODULE_ID}
				showHide={showDelete}
				editData={editData}
				onHide={hideDeleteModal}
				onReload={onReloadHandler}
				onLoading={onLoadingHandler}
			/>
		)}

		{showActivator && (
			<EntitlementActivator
				page={props.page}
				module={MODULE_ID}
				showHide={showActivator}
				editData={editData}
				onHide={hideActivatorModal}
				onReload={onReloadHandler}
				onLoading={onLoadingHandler}
			/>
		)}

		{showReceiptActivator && (
			<EntitlementActivator
				page={props.page}
				module={MODULE_ID}
				showHide={showReceiptActivator}
				editData={editData}
				type="RECEIPT"
				onHide={hideReceiptActivatorModal}
				onReload={onReloadHandler}
				onLoading={onLoadingHandler}
			/>
		)}
		</>
	);
};

export default Entitlements;
